// extracted by mini-css-extract-plugin
export default {"title":"pilih-asisten-penjual_title__ykB3L","prefix":"pilih-asisten-penjual_prefix__dRo9u","name":"pilih-asisten-penjual_name__anuML"};